package de.connect2x.timmy.brandings.lifetimeTheme

import androidx.compose.runtime.Composable
import androidx.compose.runtime.Stable
import androidx.compose.ui.graphics.Color
import de.connect2x.timmy.brandings.aokTheme.messenger_theme_dark_mention_border
import de.connect2x.trixnity.messenger.compose.view.theme.MessengerColors
import de.connect2x.trixnity.messenger.compose.view.theme.ThemeDarkMessengerColors

object ThemeDarkMessengerColorsWcImpl : ThemeDarkMessengerColors {
    @Composable
    @Stable
    override fun create(accentColor: Color): MessengerColors {
        return MessengerColors(
            success = messenger_theme_dark_success,
            presenceOnline = messenger_theme_dark_success,
            presenceOffline = messenger_theme_dark_neutral,
            presenceUnavailable = messenger_theme_dark_error,
            verificationTrusted = messenger_theme_dark_success,
            verificationUntrusted = messenger_theme_dark_error,
            verificationNeutral = messenger_theme_dark_neutral,
            metaDataPreview = messenger_theme_dark_preview_content,
            metaDataPreviewBackground = messenger_theme_dark_preview_scrim,
            blockedUser = messenger_theme_dark_error,
            warning = messenger_theme_dark_warning,
            link = messenger_theme_dark_link_other,
            linkByMe = messenger_theme_dark_link_own,
            userColors = messenger_theme_dark_users,
            mentionBorder = messenger_theme_dark_mention_border,
        )
    }
}
